/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios"
import { IMailbox, IMailboxUor } from "../shared/interfaces";
import { MailboxUor_Type } from "../shared/enums";

const controller = 'MailboxesUor';

const getMailboxesUor = (aooId: number, uorId: number, cancelToken?: CancelToken): Promise<any[]> => {
    return axiosInstance.get(`${controller}/${aooId}/${uorId}/GetMailboxesUor`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const addMailboxUor = (aooId: number, uorId: number, mailbox: IMailboxUor, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/${aooId}/${uorId}/AddMailboxUor`, mailbox, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const removeMailboxFromUor = (aooId: number, uorId: number, mailboxId: number, type: MailboxUor_Type, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.delete(`${controller}/${aooId}/${uorId}/RemoveMailboxFromUor/${mailboxId}`, { cancelToken: cancelToken, params: { type } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getMailboxesSuggestionsForCurrentUor = (aooId: number, uorId: number, filterText: string, type: MailboxUor_Type, cancelToken?: CancelToken): Promise<IMailbox[]> => {
    return axiosInstance.get(`${controller}/${aooId}/${uorId}/GetMailboxesSuggestionsForCurrentUor`, { cancelToken: cancelToken, params: { filterText, type } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

export default {
    getMailboxesUor,
    addMailboxUor,
    removeMailboxFromUor,
    getMailboxesSuggestionsForCurrentUor
}

